<template>
  <div>
    <b-tabs class="m-0" v-model="tabModel">
      <b-tab title="Equipos" :active="false">
        <equipos
          :listCategorias="listCategorias"
          :seleccionado="campeonatoSeleccionado"
          :listCampeonatos="listCampeonatos"
          @change="cambioCampeonato"
        ></equipos>
      </b-tab>
      <b-tab title="Jugadores">
        <jugadores
          :listCategorias="listCategorias"
          :listEquipos="listEquipos"
          :seleccionado="campeonatoSeleccionado"
          :listCampeonatos="listCampeonatos"
          @change="cambioCampeonato"
        ></jugadores>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select'
import {
  BFormCheckbox,
  BCard,
  BCardBody,
  BOverlay,
  BTabs,
  BTab,
  //   // BAvatar,
  //   // BBadge,
  //   //   BRow,
  //   //   BCol,
  //   //   xxxx,
  //   //   ssss,
} from 'bootstrap-vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  // watchEffect,
} from '@vue/composition-api'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  // xx
} from '../../utils/variables'
import equipos from './Equipos.vue'
import jugadores from './Jugadores.vue'

export default {
  components: {
    //   BTable,
    BFormCheckbox,
    BCard,
    BCardBody,
    vSelect,
    BOverlay,
    BTabs,
    BTab,
    equipos,
    jugadores,
    //   // BAvatar,
    //   // BBadge,
    //   // BRow,
    //   // BCol,
  },
  setup() {
    const { getApi } = apiCall()
    const tabModel = ref(0)

    const listCategorias = ref([])
    const listEquipos = ref([])
    const listCampeonatos = ref([])
    const categoriaSeleccionada = ref({
      label: 'Seleccione categoría',
      goles_no_presentacion: '0',
      value: null,
    })
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    const equipoSeleccionado = ref({
      label: 'Seleccione equipo',
      value: null,
    })

    async function getListCategorias(idTorneo, idCampeonato) {
      listCategorias.value = []
      const path = `ApiConfiguration/getCategoriasModalidad/${idTorneo}/${idCampeonato}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        data.data.forEach(element => {
          const obj = {
            label: `${element.disciplina} ${element.categoria}`,
            value: element.id_categoria,
            etapas: element.etapas,
            id_disciplina: element.id_disciplina,
            name_important: element.name_important,
            goles_no_presentacion: element.goles_no_presentacion,
            quitar_goles_no_se_presentan: element.quitar_goles_no_se_presentan,
            id_categoria: element.id_categoria,
          }
          listCategorias.value.push(obj)
        })
      } else {
        listCategorias.value = []
      }
    }
    async function getListEquipos(idCampeonato) {
      listEquipos.value = []
      const path = `ApiFixture/getTodosEquipos/${idCampeonato}`
      const data = await getApi(URL, path)
      // console.log(data.length)
      if (data.length !== 0) {
        data.forEach(element => {
          const obj = {
            label: `${element.local} `,
            value: element.id_equipo,
            foto: element.foto,
          }
          listEquipos.value.push(obj)
        })
      } else {
        listEquipos.value = []
      }
    }
    
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }

    onMounted(() => {
      // console.log(USER())
      //   cargaCategoriasTypeUser(USER().rol)
      // getEstadisticas(1)

      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's'
      )
      campeonatoSeleccionado.value = campActivo
      // console.log(refP.value)
      getListCategorias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
        campeonatoSeleccionado.value.value
      )
      getListEquipos(
        // eslint-disable-next-line
        campeonatoSeleccionado.value.value
      )
    })
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, data => {
      // console.log('watch config')
      categoriaSeleccionada.value = {
        label: 'Seleccione categoría',
        goles_no_presentacion: '0',
      }
      // selectEtapas.value = ''
      // listEtapas.value = []
      // listGrupos.value = []
      // listPartidosFixture.value = []
      getListCategorias(data.id_torneo)
    })
    function cambioCampeonato(valor) {
      campeonatoSeleccionado.value = valor
      getListEquipos(campeonatoSeleccionado.value.value)
      // console.log(campeonatoSeleccionado.value)
    }

    return {
      listCategorias,
      tabModel,
      campeonatoSeleccionado,
      equipoSeleccionado,
      listCampeonatos,
      cambioCampeonato,
      listEquipos,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
